<template>
  <Navbar />
  <Header v-bind:title="$t('_title_about')" />
  <Totop />
  <section>
    <template v-if="data.length" >
      <template v-for="emp in data" :key="emp.id">
        <template v-if="showEmp(emp.en)">
          <div class="staff-info" >
            <h2><font-awesome-icon icon="fa-solid fa-user" /> {{ showText(emp.title, emp.title_en ) }} : {{ showText(emp.name, emp.name_en) }} </h2>
            <h3>{{ $t('about_position') }}</h3>
            <ul>
              <template v-for="job in jobs" :key="job.id">
                <li v-if="job.keyid==emp.id && job.type == 1">
                    {{ showText(job.content, job.content_en) }}
                </li>
              </template>
            </ul>
            <!-- emp.pro == true -->
            <template v-if="emp.pro == true"> 
              <h3>{{ $t('about_expertise') }}</h3>
              <ul>
                <template v-for="job in jobs" :key="job.id">
                  <li v-if="job.keyid==emp.id && job.type == 0">
                    {{ showText(job.content, job.content_en) }}
                  </li>
                </template>
              </ul>
            </template>
            <h3>{{ $t('about_extension') }}： {{ emp.tel }}</h3>
          </div>
          <hr />
        </template>
      </template>
    </template>

  </section>

  <Footer />
</template>

<script>
import Navbar from "@/components/Navbar.vue";
import Header from "@/components/Header.vue";
import Footer from "@/components/Footer.vue";
import Totop from "@/components/Totop.vue";

import showText from "@/mixin/showText.js"

export default {
  name: "App",
  components: { Navbar, Header, Footer, Totop },
  mixins: [showText],

  data() {
    return {
      data: [],
      jobs: [],
    };
  },

  methods: {
    showEmp: function(en) {
      if(this.$i18n.locale == 'zh') {
        return true;
      }
      if(this.$i18n.locale == 'en') {
        if(en == true){
          return true;
        } 
        else {
          return false
        }; 
      }
    },

  },

  mounted() {
    fetch("https://oir.nccu.edu.tw/codeigniter/api/aboutuss")
      .then((respond) => respond.json())
      .then((data) => {
          this.data = data;
      })
      .catch((err) => console.log(err.message));

    fetch("https://oir.nccu.edu.tw/codeigniter/api/aboutusjob")
      .then((respond) => respond.json())
      .then((data) => {
          this.jobs = data;
      })
      .catch((err) => console.log(err.message));


  }

};
</script>

<style src="@/assets/css/about.css" scoped></style>